import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import useCurrentUserStore from "@/store";
import { getTemplateLinks } from "./TemplateLinks";

const FinalStepContent: React.FC = () => {
  const { dashboardAccessToken, selectedApp, appLoginToken, appSlug } =
    useCurrentUserStore();

  const templateLinks = getTemplateLinks(
    selectedApp,
    appSlug,
    dashboardAccessToken,
    appLoginToken
  );

  const handleCreateNewAccount = () => {
    localStorage.removeItem("current-user-store");
    window.open(window.location.href);
  };

  return (
    <div className="h-[85vh] flex flex-col justify-between  ">
      <div>
        <h2 className="font-semibold text-[28px]/[32px]">You have launched!</h2>
        <p className="text-sm text-muted-foreground">
          Congratulations! Use the links below to navigate through your app.
        </p>
        {templateLinks.length > 0 ? (
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-6">
            {templateLinks.map((link, idx) => (
              <a
                href={link.url}
                key={idx}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Card className="md:min-h-40 md:max-h-40 hover:shadow-lg transition-shadow p-0">
                  <CardHeader>
                    <div className="flex flex-row justify-between">
                      <img src={link.icon} alt="icon" className="w-8 mb-2" />
                      <img src="/arrow.svg" alt="icon" className="w-3 mb-2" />
                    </div>
                    <CardTitle >{link.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription >{link.description}</CardDescription>
                  </CardContent>
                </Card>
              </a>
            ))}
          </div>
        ) : (
          <p className="text-center text-muted-foreground mt-6">
            No links available for this app.
          </p>
        )}
      </div>

      <div>
        <button
          onClick={handleCreateNewAccount}
          className="text-blue-600 underline text-sm"
        >
          Create New Account
        </button>
      </div>
    </div>
  );
};

export default FinalStepContent;
